import { useState, useEffect } from 'react';

const Gallery = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const images = [
    {
      url: "https://static.readdy.ai/image/ad440e5983da10e2cbbc9a815800d393/20d843d8c98b7831d598151683c44d33.jpeg",
      title: "Amuse-bouches raffinés",
      description: "Créations culinaires d'exception"
    },
    {
      url: "https://static.readdy.ai/image/ad440e5983da10e2cbbc9a815800d393/fdc4d9b82872dd0986dd1340b28e2e63.png",
      title: "Plat signature",
      description: "Haute gastronomie française"
    },
    {
      url: "https://static.readdy.ai/image/ad440e5983da10e2cbbc9a815800d393/b7d1dbfd51e516cd56149f13e2513d1b.jpeg",
      title: "Buffet corporate",
      description: "Excellence professionnelle"
    },
    {
      url: "https://readdy.ai/api/search-image?query=Artistic%20dessert%20presentation%20with%20golden%20elements%2C%20French%20patisserie%20excellence%2C%20luxury%20sweet%20creations%2C%20elegant%20dessert%20plating%2C%20sophisticated%20pastry%20art%2C%20baroque%20style%20desserts&width=800&height=500&seq=gallery-5&orientation=landscape",
      title: "Desserts d'exception",
      description: "Pâtisserie artistique"
    },
    {
      url: "https://readdy.ai/api/search-image?query=Fashion%20show%20catering%20with%20creative%20finger%20foods%2C%20stylish%20food%20presentation%2C%20modern%20culinary%20art%2C%20elegant%20cocktail%20reception%2C%20luxury%20fashion%20event%20dining%2C%20contemporary%20food%20styling&width=800&height=500&seq=gallery-6&orientation=landscape",
      title: "Cocktail mode",
      description: "Créativité culinaire"
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 4000);

    return () => clearInterval(interval);
  }, [images.length]);

  const goToSlide = (index: number) => {
    setCurrentIndex(index);
  };

  const goToPrevious = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + images.length) % images.length);
  };

  const goToNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  return (
    <section id="galerie" className="py-20 bg-black">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-300 mb-8" style={{ fontFamily: 'Alice, serif' }}>
            Galerie
          </h2>
          
          <div className="flex items-center justify-center mb-8">
            <div className="w-24 h-px bg-gray-300"></div>
            <div className="w-4 h-4 bg-gray-300 rounded-full mx-6 rotate-45"></div>
            <div className="w-24 h-px bg-gray-300"></div>
          </div>

          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Découvrez nos créations culinaires et nos plus beaux événements
          </p>
        </div>

        {/* Slider principal */}
        <div className="relative max-w-6xl mx-auto">
          <div className="relative h-96 md:h-[500px] rounded-lg overflow-hidden shadow-2xl">
            <img
              src={images[currentIndex].url}
              alt={images[currentIndex].title}
              className="w-full h-full object-cover object-top transition-opacity duration-500"
            />
            
            {/* Overlay avec informations */}
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent"></div>
            <div className="absolute bottom-8 left-8 right-8">
              <h3 className="text-2xl md:text-3xl font-bold text-white mb-2" style={{ fontFamily: 'Alice, serif' }}>
                {images[currentIndex].title}
              </h3>
              <p className="text-gray-300 text-lg">
                {images[currentIndex].description}
              </p>
            </div>

            {/* Boutons de navigation */}
            <button
              onClick={goToPrevious}
              className="absolute left-4 top-1/2 transform -translate-y-1/2 w-12 h-12 bg-black/50 hover:bg-black/70 rounded-full flex items-center justify-center transition-all duration-300 cursor-pointer"
            >
              <i className="ri-arrow-left-line text-white text-xl"></i>
            </button>
            
            <button
              onClick={goToNext}
              className="absolute right-4 top-1/2 transform -translate-y-1/2 w-12 h-12 bg-black/50 hover:bg-black/70 rounded-full flex items-center justify-center transition-all duration-300 cursor-pointer"
            >
              <i className="ri-arrow-right-line text-white text-xl"></i>
            </button>
          </div>

          {/* Indicateurs */}
          <div className="flex justify-center mt-6 space-x-2">
            {images.map((_, index) => (
              <button
                key={index}
                onClick={() => goToSlide(index)}
                className={`w-3 h-3 rounded-full transition-all duration-300 cursor-pointer ${
                  index === currentIndex 
                    ? 'bg-gray-300 scale-125' 
                    : 'bg-gray-600 hover:bg-gray-400'
                }`}
              />
            ))}
          </div>
        </div>

        {/* Galerie de miniatures */}
        <div className="flex justify-center mt-12">
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 max-w-5xl">
            {images.map((image, index) => (
              <button
                key={index}
                onClick={() => setCurrentIndex(index)}
                className={`relative h-24 rounded-lg overflow-hidden transition-all duration-300 cursor-pointer hover:scale-105 ${
                  currentIndex === index
                    ? 'ring-2 ring-gray-300 scale-105'
                    : 'opacity-70 hover:opacity-100'
                }`}
              >
                <img
                  src={image.url}
                  alt={image.title}
                  className="w-full h-full object-cover object-top"
                />
                {currentIndex === index && (
                  <div className="absolute inset-0 bg-gray-300/20"></div>
                )}
              </button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Gallery;
